@if(this.contextService.contextObject?.apiBaseUrlV1) {
  <div class="page-container-public">
    <router-outlet></router-outlet>
  </div>
}
<div class="toast-container">
  <p-toast [baseZIndex]="16000" position="top-center"></p-toast>
</div>

